import { render, staticRenderFns } from "./TrashProduct.vue?vue&type=template&id=527b9fbc&"
import script from "./TrashProduct.vue?vue&type=script&lang=js&"
export * from "./TrashProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports